interface NoResultsProps {
  query: string;
  type: 'pizzerie' | 'pizze';
}

export default function NoResults({ query, type }: NoResultsProps) {
  return (
    <div className="flex flex-col items-center justify-center p-8 text-center">
      <div className="text-6xl mb-4">🔍</div>
      <h3 className="text-xl font-semibold text-gray-800 mb-2">
        Nessun risultato trovato
      </h3>
      <p className="text-gray-600 max-w-md">
        {query ? (
          <>
            La ricerca "<span className="font-medium">{query}</span>" non ha prodotto risultati per {type}.
            <br />
            Prova con termini diversi o modifica i filtri.
          </>
        ) : (
          <>
            Non ci sono {type} disponibili in questa zona.
            <br />
            Prova a spostare la mappa o a modificare i filtri.
          </>
        )}
      </p>
    </div>
  );
}